import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
	.use(initReactI18next)
	.init({
		debug: true,
		fallbackLng: 'en-US',
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		resources: {
			'en-US': {
				translation: {
					welcome_lyla: 'Welcome to LYLA Teacher',
					loading: 'Loading...',
					back: 'Back',
					view: 'View',
					cancel: 'Cancel',
					close: 'Close',
					confirm: 'Confirm',
					save: 'Save',
					add: 'Add',
					yes: 'Yes',
					remove: 'Remove',
					expand_all: 'Expand all',
					edit: 'Edit',
					discard_changes: 'Discard changes?',
					discard_changes_message: 'You have unsaved changes. Are you sure you would like to discard them?',
					this_field_is_required: 'This field is required',
					sidebar: {
						home: 'Home',
						student: 'Student',
						logout: 'Logout',
						collapse: 'Collapse',
						settings: 'SETTINGS',
						sites: 'Sites',
						all_students: 'All Students',
						my_roster: 'My Roster',
					},
					students: {
						your_students: 'Your Students',
						students: 'Students',
						no_students: 'Your roster is empty',
						description_no_students: 'To manage students, add them to your roster',
						student_not_found: 'Student not found',
						description_not_found: 'The student you are looking for does not exist.',
						date_of_birth: 'BIRTH DATE',
						SSID: 'SSID',
						search_by_student_name: 'Search by student name',
					},
					pagination: {
						page: 'Page',
						of: 'of',
					},
					navigation: {
						back_to_all_students: 'Back to all students',
						close: 'Close',
						back: 'Back',
						save: 'Save',
						delete: 'Delete',
					},
					courses: {
						all_courses: 'All courses',
						details: 'Details',
						student_no_courses: 'Your student has no courses',
						description_student_no_courses: 'This student currently has no courses. To add courses, click the \'Manage courses\' button.',
						courses: 'Courses',
						course_name: 'Course Name',
						course_id: 'Course ID',
						code: 'Code',
						manage_courses: 'Manage courses',
						students_courses: 'Student\'s courses',
						no_questions: 'This exam has no questions.',
						item_already_added: 'Item already added',
					},
					units: {
						back_to_courses: 'Back to courses',
						view_work: 'View Work',
						unit: 'Unit',
						units: 'Units',
						details: 'Details',
						no_units_for_this_course: 'No units for this course',
						description_no_units_for_this_course: '',
					},
					error: {
						message404: 'Page not found',
						description404: 'Oops! The page you\'re looking for can\'t be found.',
						message403: 'Access Denied',
						description403: 'We\'re sorry, but it looks like you don\'t have permission to view this page.',
						back_to_home_page: 'Back to home page',
						grade_cannot_exceed_maximum: 'Grade cannot exceed the total grade value',
						this_field_is_required: 'This field is required',
					},
					wip: {
						course: 'Course',
						unit: 'Unit',
						no_resources_for_this_unit: 'No resources for this unit',
						description_no_resources_for_this_unit: '',
						collapse: 'Collapse',
						resources: 'Resources',
						needs_redo: 'Needs redo',
						assessments: 'Assessments',
						pass: 'Pass',
						is_activity_complete: 'Is this activity complete?',
						is_your_assessment_complete: 'Is your assessment complete?',
						submit_next_activty: 'Submit',
						submit: 'Submit',
						skip: 'Skip',
						exam: 'Exam',
						generate_work_sample: 'Generate Work Sample',
						preparing_work_sample: 'Preparing sample',
						work_sample: 'Work Sample',
						student_has_submitted_unit_work: 'Student has submitted unit work.',
						grade_all_weighted_work: 'Grade all weighted work to calculate final grade.',
						workbook_completion_grade: 'Completion grade',
						workbook_completion: 'Workbook completion',
						workbook_description: 'A completion grade is the final grade you assign to a student ' +
							'based on their overall performance throughout the unit.  This grade reflects their effort, ' +
							'understanding, and the quality of their submitted work, including assignments, quizzes, and activites.',
						review_and_compile_unit: 'Review and compile unit',
						review_unit_description: 'Review and generate the student\'s unit work sample. ' +
							'Once it\'s processed, the download will be available here.',
						review: 'Review',
						download: 'Download',
						download_work_sample_on_course_page: 'When it\'s done, download the work sample on the course page',
						grade_cannot_be_more_than_count: 'Grade cannot be more than {{count}}',
						all_set_handed_in_your_unit: 'All set!  You\'ve successfully handed your unit in to your educator.',
						final_grde: 'Final Grade',
						final_grade_send_fail: 'Failed to send grade to the SIS',
						final_grade_send_success: 'Success! {{studentName}}\'s grade has been sent to the SIS.',
						submit_to_edi: 'Send grade to SIS',
						send_to_sis: 'Send to SIS',
						sent_to_the_sis: 'Sent to the SIS',
						send: 'Send',
						send_to_sis_info: 'Would you like LYLA to send {{studentName}}\'s final grade to your SIS?',
						comment_placeholder: 'Comments, teacher name, date stamps, etc. can be added here.',
						final_grade: 'Final grade',
						no_data_found: 'No data found',
						work_sample_bein_prepared: 'The work sample is being prepared. Please check again later.',
						send_work_sample_to_sis: 'Send work sample to SIS',
						send_to_the_sis: 'Send to the SIS',
						send_student_name_work_sample_to_sis: 'Would you like LYLA to send {{studentName}}\'s work sample to your student information system (SIS)?',
						dual_view: 'Dual view',
						single_view: 'Single view',
					},
					activity_status: {
						open: 'Not started',
						in_progress: 'In progress',
						reattempt: 'Needs redo',
						ready_for_review: 'Grade',
						ready_to_review: 'Ready to review',
						completed: 'Passed',
						skipped: 'Skipped',
						returned_to_student: 'Returned to student',
						current: 'Current',
					},
					lesson_status: {
						open: 'Not started',
						in_progress: 'In progress',
						reattempt: 'In progress',
						completed: 'Passed',
					},
					educators: {
						roster: 'Roster',
						educators: 'Educators',
						no_students: 'No students',
						description_no_students: 'This educator currently has no students. To add students, click the "Manage Roster" button.',
						description_no_students_manage: 'This educator currently has no students. To add students, click the "+" icon beside a student’s name.',
						no_educators: 'No educators',
						description_no_educators: 'There is no educator on this school.',
						manage_roster: 'Manage Roster',
						student_roster: 'Student roster',
						students_courses: 'Student\'s courses',
						name: 'NAME',
						nb_students: '# of students',
						unable_to_retrieve_educators_list: 'Unable to retrieve educators list',
						all_students: 'All students',
						all_courses: 'All courses',
						back_to_all_educators: 'Back to all educators',
						educator_not_found: 'Educator not found',
						description_educator_not_found: 'The educator you are looking for does not exist.',
						add_student_one: 'Add {{count}} student',
						add_student_other: 'Add {{count}} students',
						remove_student_one: 'Remove {{count}} student',
						remove_student_other: 'Remove {{count}} students',
						clear_all: 'Clear all',
						search_by_name: 'Search by name',
						filters: 'Filters',
						clear_all_filters: 'Clear all filters',
						view_student_one: 'View {{count}} student',
						view_student_other: 'View {{count}} students',
						clear: 'Clear',
					},
					sites: {
						sites: 'Sites',
						site: 'SITE',
						add_site: 'Add Site',
						name: 'Name',
						description: 'Description',
						edit_site: 'Edit Site',
						delete: 'Delete',
						delete_site: 'Delete Site',
						want_delete_site: 'Are you sure you want to delete {{siteName}}?',
						no_site_on_school: 'No sites found on {{schoolName}}.',
						no_students: 'No students',
						no_students_on_site: 'No students found on {{siteName}}.',
						userType: 'User Type',
						unable_to_retrieve_school_sites: 'Unable to retrieve school sites',
						unable_to_retrieve_site_students: 'Unable to retrieve site students.',
						successfully_deleted_site: 'Successfully deleted site.',
						successfully_added_site: 'Successfully added site.',
						successfully_updated_site: 'Successfully updated site.',
						unable_to_delete_site: 'Unable to delete site.',
						unable_to_add_site: 'Unable to add site.',
						unable_to_update_site: 'Unable to update site.',
						your_students: 'Your students',
						remove_student: 'Remove student',
						remove_student_message: 'Are you sure you want to remove {{studentName}} from {{siteName}}?',
						successfully_removed_student: 'Successfully removed student.',
						unable_to_remove_student: 'Unable to remove student.',
						select_students: 'Select students',
						students: 'Students',
						select_at_least_one_student: 'Please select at least one student.',
						successfully_added_students: 'Successfully added student(s).',
						unable_to_add_students: 'Unable to add student(s).',
						status: 'Status',
						email_address: 'Email',
						no_sites: 'No sites',
					},
					termsAndConditions: {
						terms_of_service: 'Terms of Service',
						agree_to_terms: 'By clicking "Continue" you agree to the ',
						terms_of_service_link: 'Terms of Service',
						continue: 'Continue',
					},
					documentType: {
						AnswerKey: 'Answer Key',
						InstructorManual: 'Instructor Manual',
						Reader: 'Reader',
						StudyGuide: 'Study Guide',
					},
					exam: {
						review_exam: 'Review exam',
						preview_exam: 'Preview exam',
						exit_preview: 'Exit preview',
						questions: 'questions',
						grade: 'Grade',
						reason: 'Reason',
						for_internal_view_only: 'For internal view only',
						comment_visible_to_students: 'Will be visible to students',
						comment: 'Comment',
						approval: 'Approval',
						return: 'Return',
						return_to_student: 'Return to student',
						accept: 'Accept',
						save_and_exit: 'Save and exit',
						returned_changed: 'Save changes',
						returned_changed_message: 'Are you sure you want to return this to your student? The student\'s work will be erased and they will be required to do the exam again.',
						override_grade: 'Override grade',
						override_grade_message: 'Are you sure you want to override this grade and save changes? The student will be able to see changes immediately.',
						approval_or_comment: 'Save changes',
						approval_or_comment_message: 'Are you sure you want to return this to your student? The student will be able to see this change immediately.',
						grade_must_be_less_than_or_equal_to: 'Grade must be less than or equal to {{count}}',
						discard_changes: 'Discard changes?',
						discard_changes_message: 'You have unsaved changes. Are you sure you would like to discard them?',
					},
					assessment: {
						exam: 'Exam',
						assessment: 'Assessment',
						alt_assessment: 'Alt. Assessment',
						debate: 'Debate Artificial Intelligence',
						teach: 'Teach the Teacher',
						art: 'Art Project',
						exam_description: 'Up to 30 multiple choice or true or false questions.',
						debate_description: 'Debate an LLM regarding the accuracy of a learning objective.',
						teach_description: 'Create and present a lesson on one of the learning objectives to your teacher.',
						art_description: 'Use your art skills to convey what you have learned in this unit.',
						preview: 'Preview assessment',
						review: 'Review assessment',
						uploaded_file: 'Uploaded file',
						submitted_link: 'Link',
					},
					worksample: {
						select_all_pages: 'Select all pages',
						select_all_final_grade_work: 'Select all graded work',
						deselect_all_pages: 'Deselect all pages',
						select: 'Select',
						selected_pages_one: '{{count}} page selected',
						selected_pages_other: '{{count}} pages selected',
						add_to_sample: 'Add to sample',
						remove_from_sample: 'Remove from sample',
						part_of_final_grade: 'Part of final grade',
						you_cannot_make_changes_work_sample: 'You cannot make changes until the work sample is done generating.',
						select_pages_to_generate_work_sample: 'Select pages to generate the work sample',
					}
				}
			}
		}
	});

export default i18n;